import React, { useCallback, useContext } from 'react';
import { Checkbox, CheckboxProps } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';

import TechnicianPasswordValidationContext from 'app/providers/TechnicianPasswordValidationProvider/context';
import {
  selectAIAnalysisDisabled,
  toggleAIAnalysisDisabled,
} from 'app/redux/viewerConfiguration/reducer';
import { Toggle, ToggleProps } from 'rsuite';
import { useIntl } from 'react-intl';

function AIAnalysisDisabledConfiguration() {
  const dispatch = useDispatch();
  const intl = useIntl();
  const requestValidation = useContext(TechnicianPasswordValidationContext);
  const isAIAnalysisDisabled: boolean = useSelector(selectAIAnalysisDisabled) ?? false;

  const onChangeAIAnalysisDisabled: ToggleProps['onChange'] = useCallback(
    (checked, event) =>
      requestValidation()
        .then(() => dispatch(toggleAIAnalysisDisabled(checked ?? false)))
        .catch(() => {}),
    [dispatch, requestValidation]
  );

  return (
    <div>
      <Toggle
        checked={isAIAnalysisDisabled}
        size="lg"
        checkedChildren={intl.formatMessage({ id: 'general.ON' })}
        unCheckedChildren={intl.formatMessage({ id: 'general.OFF' })}
        onChange={onChangeAIAnalysisDisabled}
      />
    </div>
  );
}

export default React.memo(AIAnalysisDisabledConfiguration);
